import React from "react";
import Image from "next/image";
import Link from "next/link";
import { env } from "@/lib/environment";
import { Typography } from "../ui";

export interface AppCardData {
  id: string;
  title: string;
  category: string;
  description: string;
  href: string;
  icon: string;
  previewImage: string;
  colorClass: string;
  dataCategory: string;
}

const imgBaseUrl = `${env.NEXT_PUBLIC_CDN_URL}/images/apps/`;

interface AppCardProps {
  app: AppCardData;
  className?: string;
  priority?: boolean;
}

export function AppCard({ app, className = "", priority = false }: AppCardProps) {
  return (
    <Link href={app.href} className={`border border-gray-300 hover:border-b-accent hover:shadow-md rounded-lg p-6 ${app.dataCategory} p-0 ${app.colorClass}`}>
       <Image
            src={imgBaseUrl + app.previewImage}
            className="aspect-video border-2 w-full border-black"
            alt={`${app.title} preview`}
            title={`${app.title} preview`}
            width={300}
            height={200}
            loading={priority ? "eager" : "lazy"}
            priority={priority}
            quality={80}
          />
        <div className="flex flex-row gap-3 mt-7 mb-5">
          <div className="w-10 h-10">
            <Image
              src={imgBaseUrl + app.icon}
              className="img-fluid"
              alt={`${app.title} app icon`}
              title={`${app.title} app icon`}
              loading={priority ? "eager" : "lazy"}
              priority={priority}
              width={40}
              height={40}
            />
          </div>
          <div className="flex flex-col">
            <Typography variant="h4" as="h2">{app.title}</Typography>
            <Typography variant="small" as="span" className="text-xs">{app.category}</Typography>
          </div>
        </div>
        <Typography variant="small" as="p" className="mb-6">{app.description}</Typography>

      </Link>
  );
}
